import * as Yup from 'yup';

export const getReviewValidationSchema = (phoneMandatoryForReview: boolean) => {
    return Yup.object({
        rating: Yup.number()
            .min(1, 'Rating must be at least 1 star')
            .max(5, 'Rating cannot exceed 5 stars')
            .required('Rating is required'),
        comment: Yup.string()
            .max(1000, 'Comment cannot exceed 1000 characters'),
        reviewerPhone: phoneMandatoryForReview
            ? Yup.string()
                .required('Phone number is required')
                .matches(/^[0-9]*$/, 'Phone number must contain only digits')
                .max(15, 'Phone number cannot exceed 15 digits')
            : Yup.string()
                .matches(/^[0-9]*$/, 'Phone number must contain only digits')
                .max(15, 'Phone number cannot exceed 15 digits'),
    });
};

// Default export for backwards compatibility
export const ReviewValidationSchema = getReviewValidationSchema(true);
